import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// import 'moment/min/moment-with-locales'
import { translations, updateMomentLocale } from './translation'

const getLanguage = (deviceLocale) => deviceLocale.split('_')[0]

function getLocaleFromDevice() {
  // eslint-disable-next-line global-require
  let deviceLocale
  if (typeof Intl !== 'undefined') {
    try {
      deviceLocale = Intl.NumberFormat().resolvedOptions().locale
    } catch (err) {
      // console.error("Cannot get locale from Intl")
    }
  }
  if (!deviceLocale) {
    if (window.navigator.languages) {
      [deviceLocale] = window.navigator.languages
    } else {
      deviceLocale = window.navigator.userLanguage || window.navigator.language
    }
  }
  return deviceLocale
}

// eslint-disable-next-line import/no-unresolved,import/extensions
export const detectLocale = async () => {
  let deviceLocale = null

  deviceLocale = getLocaleFromDevice() || 'en_US'
  try {
    updateMomentLocale(deviceLocale)
  } catch (error) {
    // console.log('error setting momentLocale: ', error)
  }
  return deviceLocale
}

export const detectLanguage = async () => {
  // const selectedLanguageFromStorage = process && process.env && process.env.LOCALE
  //   ? null : await AsyncStorage.getItem('@RhythmManStore:selectedLanguage')
  const deviceLocale = await detectLocale()
  if (Object.keys(translations).includes(deviceLocale)) {
    return deviceLocale
  }
  return getLanguage(deviceLocale)
}

const getLanguageDetector = (locale) => {
  const bypassDetect = () => {
    if (Object.keys(translations).includes(locale)) {
      return locale
    }
    return getLanguage(locale)
  }
  return {
    init: Function.prototype,
    type: 'languageDetector',
    detect: bypassDetect,
    cacheUserLanguage: Function.prototype,
  }
}

const LanguageDetector = {
  init: Function.prototype,
  type: 'languageDetector',
  async: true,
  detect: (callback) => detectLanguage().then((locale) => { callback(locale) }),
  cacheUserLanguage: Function.prototype,
}

export const changeLocale = (newLocale) => {
  i18n.changeLanguage(getLanguage(newLocale))
  updateMomentLocale(newLocale)
}

export const initialize = (locale) => {
  const langDetect = locale ? getLanguageDetector(locale) : LanguageDetector
  i18n
    // load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-xhr-backend
    // .use(BackendDetector)
    .use(langDetect)
    .use(initReactI18next)
    .init({
      resources: translations,
      fallbackLng: 'en',
      debug: true,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      react: {
        useSuspense: false,
      },
    })
}
